<form [formGroup]="formDatosComerciales" [ngClass]="{'disabledContent': disabledContent}">
    <div class="row">
        <div class="col">
            <div class="md-form">
                <mdb-select formControlName="formato" label="Formato" [options]="optionsFormatoProducto"
                    placeholder="Formato">
                </mdb-select>
            </div>
        </div>
        <div class="col" style="display: flex; align-items: center;" >
            <h5>Precio de costo $ {{precio_costo | numerico}}</h5>
        </div>
        <div class="row">
        <div class="col" style="display: flex; align-items: center;">
        <button mdbBtn type="submit" color="indigo" size="sm" mdbWavesEffect (click)="showEditarPrecioCosto()">Nuevo Precio de Costo</button>
      </div>
    </div>
    </div>
    <div class="row">
        <div class="col">
            <table class="table table-striped table-hover table-sm align-middle">
                <thead>
                    <tr class="grey lighten-2">
                        <th scope="col"></th>
                        <th scope="col">Lista 1</th>
                        <th scope="col">Lista 2</th>
                        <th scope="col">Lista 3</th>
                        <th scope="col">Lista 4</th>
                        <th scope="col">Lista 5</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="col">Neto ($)</td>
                        <td>
                            <input type="number" formControlName="neto1" id="cinput11" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="number" formControlName="neto2" id="cinput22" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="number" formControlName="neto3" id="cinput33" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="number" formControlName="neto4" id="cinput44" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="number" formControlName="neto5" id="cinput55" class="form-control"
                                placeholder="0" />
                        </td>
                    </tr>
                    <tr>
                        <td scope="col">Margen (%)</td>
                        <td>
                            <input type="text" formControlName="margen1" id="cinput1" class="form-control" step="0.01"
                                [value]="formDatosComerciales.get('margen1').value | numerico" placeholder="0" />
                        </td>
                        <td>
                            <input type="text" formControlName="margen2" id="cinput2" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="text" formControlName="margen3" id="cinput3" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="text" formControlName="margen4" id="cinput4" class="form-control"
                                placeholder="0" />
                        </td>
                        <td>
                            <input type="text" formControlName="margen5" id="cinput5" class="form-control"
                                placeholder="0" />
                        </td>
                    </tr>
                    <tr *ngIf="!disabledContent">
                        <td scope="col">IVA [{{parametro_iva}}%]</td>
                        <td>{{ iva1 | numerico}}</td>
                        <td>{{ iva2 | numerico}}</td>
                        <td>{{ iva3 | numerico}}</td>
                        <td>{{ iva4 | numerico}}</td>
                        <td>{{ iva5 | numerico}}</td>
                    </tr>
                    <tr *ngIf="!disabledContent">
                        <td scope="col">Impto. Adic. [{{impuestoAdicPro}}%]</td>
                        <td>{{ impAdicional1 | numerico}}</td>
                        <td>{{ impAdicional2 | numerico}}</td>
                        <td>{{ impAdicional3 | numerico}}</td>
                        <td>{{ impAdicional4 | numerico}}</td>
                        <td>{{ impAdicional5 | numerico}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="grey lighten-2" *ngIf="!disabledContent">
                        <th scope="col">Precio Final</th>
                        <th scope="col">{{ preciofinal1 | numerico}}</th>
                        <th scope="col">{{ preciofinal2 | numerico}}</th>
                        <th scope="col">{{ preciofinal3 | numerico}}</th>
                        <th scope="col">{{ preciofinal4 | numerico}}</th>
                        <th scope="col">{{ preciofinal5 | numerico}}</th>
                    </tr>
                </tfoot>
            </table>

            <!-- <h5 class="modal-title w-100 text-left" id="myModalLabel">
Flete
</h5> -->
            <!--Radio buttons-->
            <!-- <div class="row">
<div class="col flete-box">
  <div class="btn-group">
    <label mdbBtn color="info" mdbRadio="porcentajeCheck" mdbWavesEffect>
      %
    </label>
    <label mdbBtn color="info" mdbRadio="pesosCheck" mdbWavesEffect>
      $
    </label>
    <label mdbBtn color="info" mdbRadio="ningunoCheck" mdbWavesEffect>
      ninguno
    </label>
  </div>
  <div>
    <input type="text" id="cinput555" class="form-control" placeholder="" />
  </div>
</div>
</div> -->
            <!--Radio buttons-->
        </div>
    </div>
</form>

<!--Editar Precio Costo-->
<app-producto-modal-precio-costo (onPrecioCostoSeleccionado)="onPrecioCostoSeleccionado($event)">
</app-producto-modal-precio-costo>